import React from 'react';
import { observer } from 'mobx-react';
import EditSubuserRightsComponent from './Edit-subuser-rights.component';
import useEditSubuserRights from './useEditSubuserRights';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, devices, lang, state, handlers } =
        useEditSubuserRights(onClose);

    return (
        <>
            <EditSubuserRightsComponent
                lang={lang.lang}
                loading={subusers.rightsLoading || subusers.loading}
                rights={state.rights}
                serverError={subusers.serverError}
                selectedSubuser={subusers.selectedSubuser}
                selectedDevice={subusers.selectedDevice}
                devices={devices.deviceList}
                onSaveClick={handlers.handleSaveClick}
                onSendCommandsChange={handlers.handleSendCommandsChange}
                onSettingsChange={handlers.handleSettingsChange}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const EditSubuserRightsContainer = observer(Container);

export default EditSubuserRightsContainer;
